import verification from "../../assets/images/verification.png";
export function VerificationPage() {
  return (
    <div className="max-w-3xl h-full mx-auto flex flex-col gap-3 justify-center items-center">
      <img src={verification} alt="verification" />

      <p className="mb-6 font-bold text-lg  text-center">
        Kindly wait for yor verification mail while <br />
        your account setup is in progress...
      </p>
    </div>
  );
}
